// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wmlh","importantInfo":"styles_importantInfo__1MzQV"};